<div class="container my-4">
    <div class="row">
        <div class="col-12 ">
            <span class="title_header_bar">Adhoc Application Form</span>
        </div>
    </div>

    <div class="card card_content">

        <form [formGroup]="form">

            <div class="row">
                <div class="col-3" style="align-items: center;">
                    <mat-checkbox style="transform: scale(1.3);" color="primary"
                        (change)="click($event)"></mat-checkbox>
                    <label style="margin-left: 20px; font-size: large; white-space: nowrap;">
                        Is Physical Contract ?
                    </label>
                </div>
                <div class="col-3" style="align-items: center;" *ngIf="isPhysicalContract">
                    <mat-checkbox style="transform: scale(1.3);" color="primary"
                        (change)="resellerclick($event)"></mat-checkbox>
                    <label style="margin-left: 20px; font-size: large; white-space: nowrap;">
                        Is Reseller Customer ?
                    </label>
                </div>
            </div>

            <div class="card card_content mt-3" *ngIf="!isPhysicalContract">

                <div class="row mx-4">
                    <div class="col-xl-6 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Customer</mat-label>
                            <mat-select class="scrollbarcs" formControlName="customer" [panelClass]="'mat-select-panel'"
                                (selectionChange)="getuserdetails()" placeholder="Select Customer "
                                (openedChange)="onDropdownScroll($event)">
                                <mat-select-filter [displayMember]="'value'" [array]="verifyedlist"
                                    (keyup)="onSearchTextChange($event,'normal')"
                                    (filteredReturn)="onFilterChange($event,'normal')"></mat-select-filter>
                                <mat-option *ngFor="let item of filteredList    " [value]="item.key"
                                    style="overflow-y: scroll !important;">
                                    {{item.value}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-xl-6 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Service Provider</mat-label>
                            <mat-select class="scrollbarcs" formControlName="serviceProvider"
                                (selectionChange)="getproductclassification()" placeholder="Select Service Provider">
                                <mat-select-filter [displayMember]="'value'" [array]="serviceprovider"
                                    (filteredReturn)="filteredList2 = $event"></mat-select-filter>
                                <mat-option *ngFor="let item of filteredList2" [value]="item.key"
                                    style="overflow-y: scroll !important;">
                                    {{item.value}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row mx-4" *ngIf="isvumatel">
                    <div class="col-sm-12 col-md-6 mt-3">
                    </div>
                    <div class="col-sm-12 col-md-6 mt-3">
                        <div class="col-sm-12 col-md-6 align-self-center"
                            style="display: flex; justify-content: space-between; align-items: center;">
                            <label style="margin-right: 20px; font-size: large;">Is Aerial?</label>
                            <mat-checkbox formControlName="VumatelArea" style="transform: scale(1.3);"
                                color="primary"></mat-checkbox>
                        </div>
                    </div>
                </div>
                <div class="row mx-4">

                    <div class="col-sm-12 col-md-6 mt-4">
                        <mat-form-field appearance="fill" style="width: 100%;" hideRequiredMarker>
                            <mat-label>Product</mat-label>
                            <mat-select formControlName="product" placeholder="Select new Product"
                                (selectionChange)="onProductCategorySelect($event)">
                                <input matInput placeholder="Search" />
                                <mat-optgroup *ngFor="let group of filteredGroupedProducts()"
                                    [label]="group?.categoryName?.toUpperCase()">
                                    <mat-option *ngFor="let product of group.products" [value]="product.id">
                                        {{ product?.productName?.toUpperCase() }}{{
                                        product?.productCategoryName?.toUpperCase() }}
                                    </mat-option>
                                </mat-optgroup>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <!-- <div class="col-sm-12 col-md-6 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Promo Code</mat-label>
                            <input matInput maxlength="25" formControlName="promoCode" class="col-10"
                                autocomplete="off" readonly>
                        </mat-form-field>
                    </div> -->
                    <div class="col-xl-6 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Promo Code</mat-label>
                            <mat-select class="scrollbarcs" formControlName="promoCode"
                                placeholder="Select Primary Product" (selectionChange)="promofetch($event)">
                                <mat-select-filter [displayMember]="'value'" [array]="promocodelist"
                                    (filteredReturn)="filteredList7 = $event"></mat-select-filter>
                                <mat-option *ngFor="let item of promocodelist" [value]="item"
                                    style="overflow-y: scroll !important;">
                                    {{item.value}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12 col-md-6 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Reference</mat-label>
                            <input matInput maxlength="25" formControlName="reference" class="col-10" autocomplete="off"
                                placeholder="Enter reference">
                        </mat-form-field>
                    </div>
                </div>
                <div class="row mx-4">
                    <div class="col-sm-12 col-md-6 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Address Line1</mat-label>
                            <input matInput maxlength="25" formControlName="addressLine1" class="col-10"
                                autocomplete="off" placeholder="Enter addressLine1">
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12 col-md-6 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Address Line2</mat-label>
                            <input matInput maxlength="25" formControlName="addressLine2" class="col-10"
                                autocomplete="off" placeholder="Enter addressLine2">
                        </mat-form-field>
                    </div>
                </div>
                <div class="row mx-4">
                    <div class="col-sm-12 col-md-6 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>City</mat-label>
                            <input matInput appInputtext maxlength="25" formControlName="city" class="col-10"
                                autocomplete="off" placeholder="Enter city">
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12 col-md-6 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Region</mat-label>
                            <input matInput appInputtext maxlength="25" formControlName="region" class="col-10"
                                autocomplete="off" placeholder="Enter region">
                        </mat-form-field>
                    </div>
                </div>
                <div class="row mx-4">
                    <div class="col-sm-12 col-md-6 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Area code</mat-label>
                            <input matInput maxlength="6" formControlName="pinCode" placeholder="Enter pinCode"
                                class="col-10" autocomplete="off">
                        </mat-form-field>
                    </div>
                    <div class="col-xl-6 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Country</mat-label>
                            <mat-select class="scrollbarcs" formControlName="country" placeholder="Select country ">
                                <mat-select-filter [displayMember]="'value'" [array]="country"
                                    (filteredReturn)="country = $event"></mat-select-filter>
                                <mat-option *ngFor="let item of country" [value]="item.key"
                                    style="overflow-y: scroll !important;">
                                    {{item.value}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row mx-4">
                    <!-- <div class="col-xl-6 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Title</mat-label>
                            <mat-select class="scrollbarcs" formControlName="title" placeholder="Select Title">
                                <mat-select-filter [displayMember]="'value'" [array]="title"
                                    (filteredReturn)="title = $event"></mat-select-filter>
                                <mat-option *ngFor="let item of title" [value]="item.key"
                                    style="overflow-y: scroll !important;">
                                    {{item.value}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div> -->
                    <div class="col-sm-12 col-md-6 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>First Name</mat-label>
                            <input matInput appInputtext maxlength="25" formControlName="firstName" class="col-10"
                                autocomplete="off" placeholder="Enter firstName">
                        </mat-form-field>
                    </div>
                     <div class="col-sm-12 col-md-6 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Last Name</mat-label>
                            <input matInput appInputtext maxlength="25" formControlName="lastName" class="col-10"
                                autocomplete="off" placeholder="Enter lastName">
                        </mat-form-field>
                    </div>
                </div>

              <!--  <div class="row mx-4">
                   
                     <div class="col-sm-12 col-md-6 mt-4">
                        <div class="col-sm-12 col-md-12 align-self-center" style="display: flex; align-items: center;">
                            <label style="margin-right: 30px; font-size: large;">Gender</label>
                            <mat-radio-group formControlName="gender"
                                style="display: flex; flex-direction: row mx-4; gap: 80px;">
                                <mat-radio-button value="1">Male</mat-radio-button>
                                <mat-radio-button class="ml-3" value="2">Female</mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div> 

                </div>-->

                <div class="row mx-4">
                    <div class="col-xl-6 mt-4">
                        <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                            <mat-label>DOB</mat-label>
                            <input matInput [matDatepicker]="startDatePicker" [max]="maxDate"
                                formControlName="dateOfBirth" autocomplete="off" placeholder="Select DOB"
                                class="custom-input-border" (click)="startDatePicker.open()" readonly>
                            <mat-datepicker-toggle matSuffix [for]="startDatePicker" style="color:black;">
                                <button mat-icon-button>
                                    <mat-icon>event</mat-icon>
                                </button>
                            </mat-datepicker-toggle>
                            <mat-datepicker #startDatePicker startView="multi-year"></mat-datepicker>
                        </mat-form-field>
                    </div>

                    <div class="col-xl-6 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Home Language</mat-label>
                            <mat-select class="scrollbarcs" formControlName="homeLanguage"
                                placeholder="Select homeLanguage">
                                <mat-select-filter [displayMember]="'value'" [array]="languageList"
                                    (filteredReturn)="filteredList4 = $event"></mat-select-filter>
                                <mat-option *ngFor="let item of filteredList4" [value]="item.key"
                                    style="overflow-y: scroll !important;">
                                    {{item.value}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row mx-4">

                    <div class="col-sm-12 col-md-6 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>ID/Passport No</mat-label>
                            <input matInput maxlength="13" formControlName="identificationNumber" class="col-10"
                                autocomplete="off" placeholder="Enter identificationNumber">
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12 col-md-6 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Primary Contact No</mat-label>
                            <input matInput maxlength="25" formControlName="primaryContactNumber" class="col-10"
                                autocomplete="off" placeholder="Enter primaryContactNumber">
                        </mat-form-field>
                    </div>
                </div>


                <div class="row mx-4">

                    <div class="col-sm-12 col-md-6 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Mobile No</mat-label>

                            <input matInput maxlength="25" formControlName="mobileNumber" class="col-10"
                                autocomplete="off" (input)="onInputChange()" placeholder="Enter mobileNumber">
                        </mat-form-field>
                    </div>

                    <div class="col-sm-12 col-md-6 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Land Line No</mat-label>
                            <input matInput maxlength="25" formControlName="landLineNumber" class="col-10"
                                autocomplete="off" placeholder="Enter landLineNumber">
                        </mat-form-field>
                    </div>
                </div>
                <div class="row mx-4">

                    <div class="col-sm-12 col-md-6 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Email</mat-label>
                            <input matInput formControlName="email" class="col-10" autocomplete="off"
                                placeholder="Enter email">
                        </mat-form-field>
                    </div>
                </div>


                <div class="row mx-4">
                    <div class="col-sm-12 col-md-6 mt-5">
                        <div class="col-sm-12 col-md-12 align-self-center" style="display: flex; align-items: center;">
                            <label style="margin-right: 30px; font-size: large;">Ownership</label>
                            <mat-radio-group formControlName="ownerShip"
                                style="display: flex; flex-direction: row mx-4; gap: 80px;" (change)="tenent()">
                                <mat-radio-button class="pr-3" value="1">Owner</mat-radio-button>
                                <mat-radio-button value="2">Tenant</mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>

                </div>
                <div class="row mx-4" *ngIf="isshow">
                    <div class="col-sm-12 col-md-6 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Landlord's Name</mat-label>
                            <input matInput appInputtext maxlength="25" formControlName="legalOwnerName" class="col-10"
                                autocomplete="off" placeholder="Enter legalOwnerName">
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12 col-md-6 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Landlord's No</mat-label>
                            <input matInput type="number" maxlength="25" formControlName="legalOwnerContactNumber"
                                class="col-10 no-spinners" autocomplete="off"
                                placeholder="Enter legalOwnerContactNumber">
                        </mat-form-field>
                    </div>
                </div>
                <div class="d-flex justify-content-end button-style mt-3">
                    <button class="btn btn-primary mb-3 mr-3" type="button" (click)="back()" matButton>Back</button>
                    <button class="btn btn-secondary mb-3" type="submit" (click)="save()" matButton>Save</button>
                </div>

            </div>






            <!-- PhysicalContract and reseller-->
            <div class="container my-4" *ngIf="isPhysicalContract">
                <div class="row">
                    <div class="col-12 ">
                        <span class="title_header_bar">Customer Form</span>
                    </div>
                </div>
                <div class="card card_content">
                    <div class="row mx-4">
                        <div class="col-xl-6 mt-4" *ngIf="isResellerCustomer">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Customer</mat-label>
                                <mat-select class="scrollbarcs" formControlName="resellerCustomer"
                                    [panelClass]="'mat-select-panel'" (selectionChange)="getuserdetails()"
                                    placeholder="Select Reseller Customer " (openedChange)="onDropdownScroll($event)">
                                    <mat-select-filter [displayMember]="'value'" [array]="verifyedlist"
                                        (keyup)="onSearchTextChange($event,'reseller')"
                                        (filteredReturn)="onFilterChange($event,'reseller')"></mat-select-filter>
                                    <mat-option *ngFor="let item of filteredList5    " [value]="item.key"
                                        style="overflow-y: scroll !important;">
                                        {{item.value}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                    </div>
             <div class="mt-3">
                        <div class="row mx-4">
                            <!-- <div class="col-xl-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Title</mat-label>
                                    <mat-select class="scrollbarcs" formControlName="title" placeholder="Select Title ">
                                        <mat-select-filter [displayMember]="'value'" [array]="title"
                                            (filteredReturn)="title = $event"></mat-select-filter>
                                        <mat-option *ngFor="let item of title" [value]="item.key"
                                            style="overflow-y: scroll !important;">
                                            {{item.value}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div> -->
                            <div class="col-sm-12 col-md-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>First Name</mat-label>
                                    <input matInput appInputtext maxlength="25" formControlName="firstName"
                                        class="col-10" autocomplete="off" placeholder="Enter firstName">
                                </mat-form-field>
                            </div>
                            <div class="col-sm-12 col-md-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Last Name</mat-label>
                                    <input matInput appInputtext maxlength="25" formControlName="lastName"
                                        class="col-10" autocomplete="off" placeholder="Enter lastName">
                                </mat-form-field>
                            </div>
                        </div>

                        <!--<div class="row mx-4">
                            
                             <div class="col-sm-12 col-md-6 mt-4">
                                <div class="col-sm-12 col-md-12 align-self-center"
                                    style="display: flex; align-items: center;">
                                    <label style="margin-right: 30px; font-size: large;">Gender</label>
                                    <mat-radio-group formControlName="gender"
                                        style="display: flex; flex-direction: row mx-4; gap: 80px;"
                                        [disabled]="isResellerCustomer">
                                        <mat-radio-button value="1">Male</mat-radio-button>
                                        <mat-radio-button class="ml-3" value="2">Female</mat-radio-button>
                                    </mat-radio-group>
                                </div>
                            </div> 
                        </div>-->

                        <div class="row mx-4">
                            <div class="col-xl-6 mt-4">
                                <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                                    <mat-label>DOB</mat-label>
                                    <input matInput [matDatepicker]="startDatePicker" [max]="maxDate"
                                        formControlName="dateOfBirth" autocomplete="off" placeholder="Select DOB"
                                        class="custom-input-border" (click)="startDatePicker.open()" readonly>
                                    <mat-datepicker-toggle matSuffix [for]="startDatePicker" style="color:black;">
                                        <button mat-icon-button>
                                            <mat-icon>event</mat-icon>
                                        </button>
                                    </mat-datepicker-toggle>
                                    <mat-datepicker #startDatePicker startView="multi-year"></mat-datepicker>
                                </mat-form-field>
                            </div>

                            <div class="col-xl-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Home Language</mat-label>
                                    <mat-select class="scrollbarcs" formControlName="homeLanguage"
                                        placeholder="Select Home Language">
                                        <mat-select-filter [displayMember]="'value'" [array]="languageList"
                                            (filteredReturn)="filteredList4 = $event"></mat-select-filter>
                                        <mat-option *ngFor="let item of filteredList4" [value]="item.key"
                                            style="overflow-y: scroll !important;">
                                            {{item.value}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>


                        <div class="row mx-4">
                            <div class="col-sm-12 col-md-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>ID/Passport No</mat-label>
                                    <input matInput maxlength="13" formControlName="identificationNumber" class="col-10"
                                        autocomplete="off" placeholder="Enter identificationNumber"
                                        (input)="fillDOBGender($event, form)">

                                </mat-form-field>
                            </div>
                            <div class="col-sm-12 col-md-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Primary Contact No</mat-label>
                                    <input matInput maxlength="12" formControlName="primaryContactNumber" class="col-10"
                                        autocomplete="off" (input)="onPrimaryContactInputChange()"
                                        placeholder="Enter primaryContactNumber">
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="row mx-4">

                            <div class="col-sm-12 col-md-6 mt-4" *ngIf="false">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Mobile No</mat-label>
                                    <input matInput maxlength="12" formControlName="mobileNumber" class="col-10"
                                        autocomplete="off" (input)="onInputChange()" placeholder="Enter mobileNumber">
                                </mat-form-field>
                            </div>
                            <div class="col-sm-12 col-md-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Land Line No</mat-label>
                                    <input matInput maxlength="12" formControlName="landLineNumber"
                                        placeholder="Enter landLineNumber" (input)="onLandLineInputChange()"
                                        class="col-10" autocomplete="off">
                                </mat-form-field>
                            </div>
                            <div class="col-sm-12 col-md-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker class="custom-email-field">
                                    <mat-label>Email</mat-label>
                                    <input matInput formControlName="email" (blur)="onEmailEnter()"
                                        placeholder="Enter email" autocomplete="off">
                                    <mat-error *ngIf="emailError" class="custom-error">{{ emailError }}</mat-error>
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="row mx-4">
                             <div class="col-sm-12 col-md-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Reference</mat-label>
                                    <input matInput formControlName="reference" class="col-10" autocomplete="off"
                                        placeholder="Enter reference">
                                </mat-form-field>
                            </div>
                            <div class="col-sm-12 col-md-6 mt-5">
                                <div class="col-sm-12 col-md-12 align-self-center"
                                    style="display: flex; align-items: center;">
                                    <label style="margin-right: 30px; font-size: large;">Ownership</label>
                                    <mat-radio-group formControlName="ownerShip"
                                        style="display: flex; flex-direction: row mx-4; gap: 80px;"
                                        (change)="physicaltenent()" [disabled]="isResellerCustomer">
                                        <mat-radio-button class="pr-3" value="1">Owner</mat-radio-button>
                                        <mat-radio-button value="2">Tenant</mat-radio-button>
                                    </mat-radio-group>
                                </div>
                            </div>
                           
                        </div>


                        <div class="row mx-4">
                            <div class="col-sm-12 col-md-6 mt-4" *ngIf="ispshow">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Landlord's Name</mat-label>
                                    <input matInput appInputtext formControlName="legalOwnerName" class="col-10"
                                        autocomplete="off" placeholder="Enter legalOwnerName">
                                </mat-form-field>
                            </div>

                            <div class="col-sm-12 col-md-6 mt-4" *ngIf="ispshow">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Landlord's No</mat-label>
                                    <input type="number" matInput maxlength="12"
                                        formControlName="legalOwnerContactNumber" class="col-10 no-spinners"
                                        autocomplete="off" placeholder="Enter legalOwnerContactNumber">
                                </mat-form-field>
                            </div>
                        </div>


                        <div class="container my-4" *ngIf="isResellerCustomer">
                            <div class="row">
                                <div class="col-12 ">
                                    <span class="title_header_bar">Additional Information -Customer Details</span>
                                </div>
                            </div>
                            <div class="card card_content">
                                <div class="row mx-4">
                                    <div class="col-sm-12 col-md-6 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>First Name</mat-label>
                                            <input matInput appInputtext formControlName="personname" class="col-10"
                                                autocomplete="off" placeholder="Enter personname">
                                        </mat-form-field>
                                    </div>
                                    <div class="col-sm-12 col-md-6 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>Last Name</mat-label>
                                            <input matInput appInputtext formControlName="personLastName" class="col-10"
                                                autocomplete="off" placeholder="Enter personLastName">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="row mx-4">
                                    <div class="col-sm-12 col-md-6 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>Cell Phone</mat-label>
                                            <input matInput maxlength="12" formControlName="BusinessmobileNumber"
                                                placeholder="Enter BusinessmobileNumber" class="col-10"
                                                autocomplete="off" (input)="onInputChange()">
                                        </mat-form-field>
                                    </div>
                                    <div class="col-sm-12 col-md-6 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>Email</mat-label>
                                            <input matInput formControlName="businessemail" class="col-10"
                                                autocomplete="off" placeholder="Enter businessemail">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="row mx-4">
                                    <div class="col-sm-12 col-md-6 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>Id / Passport</mat-label>
                                            <input matInput maxlength="25" formControlName="personIdentification"
                                                class="col-10" autocomplete="off"
                                                placeholder="Enter personIdentification">
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="container my-4" *ngIf="isPhysicalContract">
                            <div class="row">
                                <div class="col-12 ">
                                    <span class="title_header_bar">Address Details</span>
                                </div>
                            </div>
                            <div class="card card_content">
                                <div class="row mx-4">
                                    <div class="col-sm-12 col-md-6 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>Address Line1</mat-label>
                                            <input matInput maxlength="25" formControlName="addressLine1" class="col-10"
                                                autocomplete="off" placeholder="Enter addressLine1">
                                        </mat-form-field>
                                    </div>
                                    <div class="col-sm-12 col-md-6 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>Address Line2</mat-label>
                                            <input matInput maxlength="25" formControlName="addressLine2" class="col-10"
                                                autocomplete="off" placeholder="Enter addressLine2">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="row mx-4">
                                    <div class="col-sm-12 col-md-6 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>City</mat-label>
                                            <input matInput appInputtext maxlength="25" formControlName="city"
                                                class="col-10" autocomplete="off" placeholder="Enter city">
                                        </mat-form-field>
                                    </div>
                                    <div class="col-sm-12 col-md-6 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>Region</mat-label>
                                            <input matInput appInputtext maxlength="25" formControlName="region"
                                                class="col-10" autocomplete="off" placeholder="Enter region">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="row mx-4">
                                    <div class="col-sm-12 col-md-6 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>Area code</mat-label>
                                            <input matInput maxlength="6" formControlName="pinCode" class="col-10"
                                                autocomplete="off" placeholder="Enter pinCode">
                                        </mat-form-field>
                                    </div>
                                    <div class="col-xl-6 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>Country</mat-label>
                                            <mat-select class="scrollbarcs" formControlName="country"
                                                placeholder="Select Country">
                                                <mat-select-filter [displayMember]="'value'" [array]="country"
                                                    (filteredReturn)="country = $event"></mat-select-filter>
                                                <mat-option *ngFor="let item of country" [value]="item.key"
                                                    style="overflow-y: scroll !important;">
                                                    {{item.value}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="container my-4" *ngIf="isPhysicalContract">
                            <div class="row">
                                <div class="col-12 ">
                                    <span class="title_header_bar">Product Details</span>
                                </div>
                            </div>
                            <div class="card card_content">
                                <div class="row mx-4">
                                    <div class="col-xl-6 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>Service Provider</mat-label>
                                            <mat-select class="scrollbarcs" formControlName="serviceProvider"
                                                (selectionChange)="getproductclassification()"
                                                placeholder="Select Service Provider">
                                                <mat-select-filter [displayMember]="'value'" [array]="serviceprovider"
                                                    (filteredReturn)="filteredList2 = $event"></mat-select-filter>
                                                <mat-option *ngFor="let item of filteredList2" [value]="item.key"
                                                    style="overflow-y: scroll !important;">
                                                    {{item.value}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-sm-12 col-md-6 mt-4">
                                        <mat-form-field appearance="fill" style="width: 100%;" hideRequiredMarker>
                                            <mat-label>Product</mat-label>
                                            <mat-select formControlName="product" placeholder="Select new Product"
                                                (selectionChange)="onProductCategorySelect($event)">
                                                <input matInput placeholder="Search" />
                                                <mat-optgroup *ngFor="let group of filteredGroupedProducts()"
                                                    [label]="group?.categoryName?.toUpperCase()">
                                                    <mat-option *ngFor="let product of group.products"
                                                        [value]="product.id">
                                                        {{ product?.aliasName?.toUpperCase() }}{{
                                                        product?.productCategoryName?.toUpperCase() }}
                                                    </mat-option>
                                                </mat-optgroup>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>

                                </div>
                                <div class="row mx-4">
                                    <div class="col-sm-12 col-md-6 mt-4" *ngIf="isvumatel">
                                        <div class="col-sm-12 col-md-6 align-self-center"
                                            style="display: flex; justify-content: space-between; align-items: center;">
                                            <label style="margin-right: 20px; font-size: large;">Is Aerial?</label>
                                            <mat-checkbox formControlName="VumatelArea" style="transform: scale(1.3);"
                                                color="primary"></mat-checkbox>
                                        </div>
                                    </div>


                                    <div class="col-xl-6 mt-4" *ngIf="!isResellerCustomer">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>Promo Code</mat-label>
                                            <mat-select class="scrollbarcs" formControlName="promoCode"
                                                placeholder="Select Primary Product ">
                                                <mat-select-filter [displayMember]="'value'" [array]="promocodelist"
                                                    (filteredReturn)="filteredList7 = $event"></mat-select-filter>
                                                <mat-option *ngFor="let item of promocodelist" [value]="item.value"
                                                    style="overflow-y: scroll !important;">
                                                    {{item.value}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="container my-4" *ngIf="isPhysicalContract">
                            <div class="row">
                                <div class="col-12 ">
                                    <span class="title_header_bar">Document Details</span>
                                </div>
                            </div>
                            <div class="card card_content">
                                <div class="table-responsive mt-2 ">
                                    <mat-table #table [dataSource]="dataSource">

                                        <ng-container matColumnDef="DocumentType" class="mat-table">
                                            <mat-header-cell *matHeaderCellDef>Document Type</mat-header-cell>
                                            <mat-cell *matCellDef="let dataField">
                                                <p class="text-truncate txtalign"> {{dataField.documenttype}}</p>
                                            </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="Date" class="mat-table">
                                            <mat-header-cell *matHeaderCellDef>Date</mat-header-cell>
                                            <mat-cell *matCellDef="let dataField">
                                                <p class="text-truncate txtalign">{{dataField.date}}</p>
                                            </mat-cell>
                                        </ng-container>
                                        <ng-container matColumnDef="FileName" class="mat-table">
                                            <mat-header-cell *matHeaderCellDef> File Name</mat-header-cell>
                                            <mat-cell *matCellDef="let dataField">
                                                <p class="text-truncate txtalign">{{dataField.filename}} </p>
                                            </mat-cell>
                                        </ng-container>
                                        <ng-container matColumnDef="Action" class="mat-table">
                                            <mat-header-cell *matHeaderCellDef>Action</mat-header-cell>
                                            <mat-cell *matCellDef="let dataField">
                                                <div class="text-truncate text-center">
                                                    <i style="cursor: pointer;font-size: 20px;color: #9B02DB;"
                                                        class="fa fa-file-import mr-3" *ngIf="!dataField.action"
                                                        (click)="fileupload(dataField.id)"></i>
                                                    <i style="cursor: pointer;font-size: 20px;color: red;"
                                                        class="fa fa-close mr-3" *ngIf="dataField.action"
                                                        (click)="fileupload(dataField.id)"></i>
                                                </div>
                                            </mat-cell>
                                        </ng-container>


                                        <mat-header-row
                                            *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>

                                        <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple>
                                        </mat-row>
                                    </mat-table>
                                </div>
                            </div>
                        </div>

                        <div class="container my-4" *ngIf="isPhysicalContract">
                            <div class="row">
                                <div class="col-12 ">
                                    <span class="title_header_bar">Debit Form Details</span>
                                </div>
                            </div>
                            <div class="card card_content">
                                <div class="row mx-4">
                                    <div class="col-sm-12 col-md-6 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>Given by(name of account holder)</mat-label>
                                            <input matInput appInputtext maxlength="25"
                                                formControlName="accountHolderName"
                                                placeholder="Enter Name of account holder" class="col-10"
                                                autocomplete="off">
                                        </mat-form-field>
                                    </div>
                                    <div class="col-sm-12 col-xl-6 mt-4">

                                        <mat-form-field appearance="fill" hideRequiredMarker
                                            [ngClass]="'textArea-mat-field'" style="border-radius: 0 !important;">
                                            <mat-label>Address</mat-label>
                                            <textarea rows="4" matInput type="text" placeholder="Enter Address"
                                                formControlName="address" autocomplete="off" specialIsAlphaNumeric
                                                class="col-12"></textarea>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="row mx-4">
                                    <div class="col-xl-6 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>Bank</mat-label>
                                            <mat-select class="scrollbarcs" formControlName="bank"
                                                (selectionChange)="getbranchcode()" placeholder="Select Bank ">
                                                <mat-select-filter [displayMember]="'value'" [array]="banklist"
                                                    (filteredReturn)="filteredList6 = $event"></mat-select-filter>
                                                <mat-option *ngFor="let item of filteredList6" [value]="item.name"
                                                    style="overflow-y: scroll !important;">
                                                    {{item.name}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-sm-12 col-md-6 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>Branch Code</mat-label>
                                            <input matInput maxlength="25" formControlName="code"
                                                placeholder="Enter  Bank code" class="col-10" autocomplete="off">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="row mx-4">
                                    <div class="col-sm-12 col-md-6 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>Account NO</mat-label>
                                            <input matInput maxlength="25" (keypress)="restrictSpace($event)"
                                                formControlName="accountNumber" placeholder="Enter Account Number"
                                                class="col-10" autocomplete="off">
                                        </mat-form-field>
                                    </div>
                                    <div class="col-xl-6 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>Type Of Account</mat-label>
                                            <mat-select class="scrollbarcs" formControlName="accountType"
                                                placeholder="Select Type Of Account">
                                                <mat-select-filter [displayMember]="'value'" [array]="typeofaccount"
                                                    (filteredReturn)="typeofaccount = $event"></mat-select-filter>
                                                <mat-option *ngFor="let item of typeofaccount" [value]="item.key"
                                                    style="overflow-y: scroll !important;">
                                                    {{item.value}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="row mx-4">
                                    <div class="col-sm-12 col-md-6 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>Monthly Amount(ZAR)</mat-label>
                                            <input matInput maxlength="25" formControlName="amount"
                                                placeholder="Enter Monthly Ammount" class="col-10" autocomplete="off">
                                        </mat-form-field>
                                    </div>
                                    <div class="col-xl-6 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>Date Of Debit Order Run</mat-label>
                                            <mat-select class="scrollbarcs" formControlName="dateOfDebitOrderRun"
                                                placeholder="Select Date of debit order run">
                                                <mat-select-filter [displayMember]="'value'" [array]="debitorder"
                                                    (filteredReturn)="debitorder = $event"></mat-select-filter>
                                                <mat-option *ngFor="let item of debitorder" [value]="item.key"
                                                    style="overflow-y: scroll !important;">
                                                    {{item.value}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="row mx-4">
                                    <div class="col-sm-12 col-md-6 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>Once Off Amount(ZAR)</mat-label>
                                            <input matInput maxlength="25" formControlName="onceOffFee"
                                                placeholder="Enter Once Off Amount" class="col-10" autocomplete="off">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="row mx-4">
                                    <div class="col-sm-12 col-md-6 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>To (name of beneficiary)</mat-label>
                                            <input matInput appInputtext maxlength="25"
                                                formControlName="beneficiaryName" placeholder="Enter Once Off Amount"
                                                class="col-10" autocomplete="off">
                                        </mat-form-field>
                                    </div>
                                    <div class="col-sm-12 col-md-6 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>Abbreviated name registered with the bank</mat-label>
                                            <input matInput appInputtext maxlength="25"
                                                formControlName="abbreviatedName" placeholder="Enter Once Off Amount"
                                                class="col-10" autocomplete="off">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="row mx-4">
                                    <div class="col-sm-12 col-xl-6 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker
                                            [ngClass]="'textArea-mat-field'" style="border-radius: 0 !important;">
                                            <mat-label>Beneficiary's Address</mat-label>
                                            <textarea rows="4" matInput type="text"
                                                placeholder="Enter Beneficiary's Address"
                                                formControlName="beneficiaryAddress" autocomplete="off"
                                                specialIsAlphaNumeric class="col-12"></textarea>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-sm-12 col-md-12 mt-3">
                                        <div class="col-sm-12 col-md-12 align-self-center"
                                            style="display: flex;  align-items: center;">
                                            <mat-checkbox style="transform: scale(1.3);" color="primary"
                                                (change)="showip($event.checked)"></mat-checkbox>
                                            <label style="margin-left: 25px; font-size: medium;"> I here by grant
                                                permission for Home-Connect Pty Ltd to debit my Account as per the above
                                                instruction</label>
                                        </div>
                                    </div>
                                    <div class="col-md-12 ml-5" *ngIf="dateip">
                                        <p>(Agreed on <span style="color: #9a00da;"> {{date}} </span>from IP Address :
                                            {{ip}})</p>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-end button-style mt-5">
                                    <button class="btn btn-primary mb-2 mr-3" type="button" (click)="back()"
                                        matButton>Back</button>
                                    <button class="btn btn-secondary mb-2" type="submit" (click)="physicalsave()"
                                        [disabled]="dis" matButton>Save</button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </form>
    </div>
</div>